@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivertargets
import com.narbase.letsgo.dto.core.KmmLong

class DriverTargetDto(
    val id: KmmLong?,
    val targetId: KmmLong,
    val driverId: KmmLong,
    val ridesCount: Int,
    val prizeAmount: Double?,
    val isClaimed: Boolean,
    val isSeen: Boolean
)